// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a65c5686","239":"9b0e595f","453":"d6872f1c","732":"85815701","762":"2ab662a2","833":"38689c60"}[chunkId] + ".chunk.js";
};